import { memo } from 'react';

import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';
import PropTypes from 'prop-types';

import { NumberStepStyled } from './EducationStepLabel.styles';

const EducationStepLabel = ({ step, total, number }) => (
  <Stack
    alignItems="center"
    direction="row"
    spacing="16px"
  >
    {total > 1 && (
      <NumberStepStyled
        aria-label={`step ${number} of ${total}`}
        size="md"
        weight="medium"
      >
        {number}
      </NumberStepStyled>
    )}
    <Heading
      size="3xl"
      weight="bold"
    >
      {step?.title}
    </Heading>
  </Stack>
);

export default memo(EducationStepLabel);

EducationStepLabel.propTypes = {
  step: PropTypes.shape({
    title: PropTypes.string
  }),
  total: PropTypes.number,
  number: PropTypes.number
};
